// ============================================================================
// mediaPlayback.ts — SSoT «играет только один»: запуск нового медиа
// останавливает предыдущее (как в мессенджерах). Регистрируется любым
// проигрывателем (MediaPlayer) — единая точка, без дублирования в компонентах.
// ============================================================================

type StopFn = () => void;

let current: { id: number; stop: StopFn } | null = null;
let seq = 0;

/** Новый идентификатор проигрывателя. */
export function mediaPlaybackId(): number {
  seq += 1;
  return seq;
}

/** Заявить воспроизведение: останавливает текущий, если это не мы. */
export function claimPlayback(id: number, stop: StopFn): void {
  if (current && current.id !== id) {
    try {
      current.stop();
    } catch {
      /* остановка предыдущего — best effort */
    }
  }
  current = { id, stop };
}

/** Освободить (пауза/завершение/размонтирование). */
export function releasePlayback(id: number): void {
  if (current && current.id === id) {
    current = null;
  }
}
